import { render, staticRenderFns } from "./SizesForm.vue?vue&type=template&id=9f837e56&scoped=true&"
import script from "./SizesForm.vue?vue&type=script&lang=js&"
export * from "./SizesForm.vue?vue&type=script&lang=js&"
import style0 from "./SizesForm.vue?vue&type=style&index=0&id=9f837e56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f837e56",
  null
  
)

export default component.exports